import { useEffect } from 'react'
import { ensureGtmContainer } from './ensureGtmContainer'

export const useSchoolGtm = (gtmId: string | undefined) => {
  useEffect(() => {
    ensureGtmContainer(gtmId)
  }, [gtmId])
}
